import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import {
  BLACKLIST_ADD_MODAL_STAGES,
  blacklistedMenteeDetailSelector,
  setInputErrors,
  setPersonalisedMenteeEmailersAddModalStage,
  useCreateBlacklistMutation,
} from 'features/communicationManagement';
import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import styles from './PersonalisedMenteeEmailersAddConfirmButton.module.scss';

export default function PersonalisedMenteeEmailersAddConfirmButton() {
  const dispatch = useDispatch();
  const snoozeLearnerDetail = useSelector(blacklistedMenteeDetailSelector);

  const [createRequestAdd, { isSuccess, isLoading, error }] =
    useCreateBlacklistMutation();

  const handleConfirmClick = useCallback(() => {
    dispatch(setInputErrors(null));
    createRequestAdd(snoozeLearnerDetail);
  }, [createRequestAdd, dispatch, snoozeLearnerDetail]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Email notifications for the learner are snoozed');
      dispatch(
        setPersonalisedMenteeEmailersAddModalStage(
          BLACKLIST_ADD_MODAL_STAGES.close
        )
      );
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <Tappable
      className={classNames(styles.action, 'p-v-xxs', 'm-t-m')}
      onClick={handleConfirmClick}
      disabled={isLoading}
    >
      Confirm
    </Tappable>
  );
}
